"use client";

import { useRouter } from "next/navigation";
import cx from "classnames";
import GoBackIcon from "../../icons/go-back-icon";
import styles from "./styles.module.scss";
import { Translations } from "../../../utils/translations";

interface IBackButton {
  className?: string;
  translations: Translations;
}

export default function BackButton({ className }: IBackButton) {
  const router = useRouter();

  return (
    <button aria-label={"go back"} className={cx(styles.button, className)} onClick={() => router.back()}>
      <GoBackIcon />
    </button>
  );
}
